import { render } from "./CookieConsentModal.vue?vue&type=template&id=aae79a7a"
import script from "./CookieConsentModal.vue?vue&type=script&lang=js"
export * from "./CookieConsentModal.vue?vue&type=script&lang=js"

import "./CookieConsentModal.vue?vue&type=style&index=0&id=aae79a7a&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__